module.exports = __webpack_public_path__ + "img/img_index_banner_planet@2x.be5c7a37.png";